import crypto from 'crypto';
import { useMemo } from 'react';
import { NLPSearchResultFormat } from '../../../ai-answer-dialog';
import { NLPSearchJSONResultFormat } from '../../../ai-answer-dialog/types';
import { getTypedJSONResultDataAssistanceService } from '../../../ai-answer-dialog/utils/getTypedJSONResultData';
export var getCardType = function getCardType(_ref) {
  var isReadingAids = _ref.isReadingAids,
    answerFormat = _ref.answerFormat,
    parsedType = _ref.parsedType;
  if (isReadingAids) {
    return 'definition';
  }
  if (answerFormat === NLPSearchResultFormat.JSON && parsedType === NLPSearchJSONResultFormat.WHO) {
    return 'people';
  }
  if (answerFormat === NLPSearchResultFormat.JSON && parsedType === NLPSearchJSONResultFormat.WORK) {
    return 'work';
  }
  return 'SAIN';
};
export var getParsedType = function getParsedType(_ref2) {
  var answerFormat = _ref2.answerFormat,
    answerString = _ref2.answerString;
  if (answerFormat !== NLPSearchResultFormat.JSON) {
    return undefined;
  }
  return getTypedJSONResultDataAssistanceService(answerString).parsedType;
};
export var useSessionId = function useSessionId(_ref3) {
  var userId = _ref3.userId,
    cloudId = _ref3.cloudId,
    source = _ref3.source;
  return useMemo(function () {
    return crypto.createHash('sha256').update("".concat(userId, "-").concat(cloudId, "-").concat(Date.now().toString(), "-").concat(source)).digest('hex');
  }, [userId, cloudId, source]);
};